import * as yup from 'yup';

export const categoryValidationSchema = yup
  .object({
    name: yup.string().trim().required(),
    description: yup.string(),
  })
  .required();

export type ValidCategoryFormValues = yup.Asserts<typeof categoryValidationSchema>;
